import React, { Dispatch } from 'react'
import styled from 'styled-components'
import { RequiredBudge } from '../../atoms/RequiredBudge'
import {
  useChange,
  useHandleChangeEmail,
  useHandleChangeFirstName,
  useHandleChangeLastName,
  useHandleChangePhone,
  useHandleChangeStoreName,
} from './hooks'
import { UiState } from '../../../types'
import { PrivacyPolicyDescription } from '../../molecules/PrivacyPolicyDescription'
import { TextBoxWithValidation } from '../../molecules/TextBoxWithValidation'

type Props = {
  isShow: boolean
  state: UiState
  setState: Dispatch<React.SetStateAction<UiState>>
  marketoFormRef: React.RefObject<HTMLFormElement>
}

export const FormBlock: React.FC<Props> = props => {
  const { isShow, state, setState, marketoFormRef } = props

  const handleChangeStoreName = useHandleChangeStoreName(state, setState)
  const handleChangeLastName = useHandleChangeLastName(state, setState)
  const handleChangeFirstName = useHandleChangeFirstName(state, setState)
  const handleChangeEmail = useHandleChangeEmail(state, setState)
  const handleChangePhone = useHandleChangePhone(state, setState)
  useChange(marketoFormRef, state)

  return (
    <Wrapper $isShow={isShow}>
      <StoreName>
        <LabelLine>
          <Label>店舗名</Label>
          <RequiredBudge />
        </LabelLine>
        <TextBoxWithValidation
          type="text"
          placeholder="Airレジ オーダー居酒屋"
          value={state.storeName.value}
          onChange={handleChangeStoreName}
          $errors={state.storeName.errors}
        />
      </StoreName>
      <Name>
        <LabelLine>
          <Label>担当者</Label>
          <RequiredBudge />
        </LabelLine>
        <TwoColumn>
          <LastName>
            <NameSubLabel>姓</NameSubLabel>
            <TextBoxWithValidation
              type="text"
              placeholder="青空"
              value={state.lastName.value}
              onChange={handleChangeLastName}
              $errors={state.lastName.errors}
            />
          </LastName>
          <FirstName>
            <NameSubLabel>名</NameSubLabel>
            <TextBoxWithValidation
              type="text"
              placeholder="太郎"
              value={state.firstName.value}
              onChange={handleChangeFirstName}
              $errors={state.firstName.errors}
            />
          </FirstName>
        </TwoColumn>
      </Name>
      <Email>
        <LabelLine>
          <Label>担当者メールアドレス</Label>
          <RequiredBudge />
        </LabelLine>
        <TextBoxWithValidation
          type="email"
          placeholder="airreg.order@mail.com"
          value={state.email.value}
          onChange={handleChangeEmail}
          $errors={state.email.errors}
        />
      </Email>
      <Phone>
        <LabelLine>
          <Label>担当者電話番号</Label>
          <RequiredBudge />
          <PhoneSubLabel>※ハイフンなし</PhoneSubLabel>
        </LabelLine>
        <TextBoxWithValidation
          type="tel"
          placeholder="09012345678"
          value={state.phone.value}
          onChange={handleChangePhone}
          $errors={state.phone.errors}
        />
      </Phone>
      <PrivacyPolicyDescription />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $isShow: boolean }>`
  transition:
    height 0.2s linear,
    opacity 0.2s ease-in;
  height: ${props => (props.$isShow ? '400px' : 0)};
  opacity: ${props => (props.$isShow ? 1 : 0)};
  overflow: hidden;
`

const StoreName = styled.div``
const Name = styled.div`
  margin-top: 14px;
`
const Email = styled.div`
  margin-top: 14px;
`
const Phone = styled.div`
  margin-top: 14px;
  margin-bottom: 8px;
`

const LabelLine = styled.div`
  text-align: left;
`

const Label = styled.span`
  margin-right: 5px;
  color: #555;
  font-weight: 600;
  font-size: 12px;
`

const TwoColumn = styled.div`
  display: flex;
`

const LastName = styled.div`
  width: 50%;
  padding-right: 4px;
`

const FirstName = styled.div`
  width: 50%;
  padding-left: 4px;
`

const NameSubLabel = styled.div`
  margin-bottom: 2px;
  color: #555;
  font-size: 12px;
  font-weight: 300;
  text-align: left;
`

const PhoneSubLabel = styled.span`
  margin-left: 5px;
  color: #999;
  font-size: 11px;
  font-weight: 300;
`
